import {NavigateOptions, useNavigate} from 'react-router-dom';

const FADE_DURATION = 180;

const useFadeNavigate = () => {
  const navigate = useNavigate();

  return (to: string | number, options?: NavigateOptions) => {
    const main = document.querySelector('main') as HTMLElement | null;
    if (!main) {
      typeof to === 'number' ? navigate(to) : navigate(to, options);
      return;
    }
    main.style.transition = `opacity ${FADE_DURATION}ms ease`;
    main.style.opacity = '0';
    setTimeout(() => {
      typeof to === 'number' ? navigate(to) : navigate(to, options);
      requestAnimationFrame(() => {
        main.style.opacity = '1';
      });
    }, FADE_DURATION);
  };
};

export default useFadeNavigate;
